'use strict';

export function timeZoneDate(dateObj, timeZone){
	if(!(dateObj instanceof Date) || isNaN(dateObj.getTime())){
		return null;
	}
	const parts = new Intl.DateTimeFormat('en-US', {
		timeZone: timeZone,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hourCycle: 'h23'
	}).formatToParts(dateObj);
	const values = {};
	for(const part of parts){
		values[part.type] = part.value;
	}
	return new Date(
		Number(values.year),
		Number(values.month) - 1,
		Number(values.day),
		Number(values.hour),
		Number(values.minute),
		Number(values.second)
	);
}
